'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.RESULTS_LIST_VIEW_TYPE = exports.CARDS_LIST_VIEW_TYPE = exports.CARDS_PREFERRED_TAB = undefined;
exports.getPrefValue = getPrefValue;

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CARDS_PREFERRED_TAB = exports.CARDS_PREFERRED_TAB = 'cdt_tab_pref';
var CARDS_LIST_VIEW_TYPE = exports.CARDS_LIST_VIEW_TYPE = 'cdt_list_pref';
var RESULTS_LIST_VIEW_TYPE = exports.RESULTS_LIST_VIEW_TYPE = 'rsp_list_pref';

function getValuesIfExist(value, possibleValues) {
    return value in possibleValues;
}

function getPrefValue(prefType, prefDefaultValue) {
    return localStorage.getItem(prefType) || prefDefaultValue;
}

function buildUrl(className, prefType, prefDefaultValue, possibleValues) {
    var prefValue = void 0;

    (0, _jquery2.default)(document).on('touchstart mousedown', '.' + className, function (e) {
        var $target = (0, _jquery2.default)(e.currentTarget);

        function updateHref(value) {
            $target.attr('href', function (index, href) {
                return '' + href.replace(/\/$/, '') + possibleValues[value];
            });
            $target.removeClass(className);
        }

        if (prefValue) {
            updateHref(prefValue);
        } else {
            prefValue = getPrefValue(prefType, prefDefaultValue);
            updateHref(prefValue);
        }
    });
}

function setPref(selector, storageKeyName, possibleValues) {
    var value = (0, _jquery2.default)(selector).attr('data-pref-type');
    if (!getValuesIfExist(value, possibleValues)) {
        return;
    }

    if (value) {
        try {
            localStorage.setItem(storageKeyName, value);
        } catch (e) {
            /* eslint-disable no-console */
            console.warn('You are in a private mode, so, we couldn\'t save your preference.');
        }
    }
}

function navigate() {
    var cardTabsPossibleValues = {
        free: '/',
        pro: '/pro',
        'at-a-glance': '/at-a-glance',
        'odds-comparison': '/odds-comparison',
        'raceday-live': '/raceday-live'
    };
    var cardListTypePossibleValues = {
        byCourse: '/',
        byTime: '/time-order'
    };

    var resultsListTypePossibleValues = {
        byCourse: '/',
        byTime: '/time-order'
    };

    // Racecards tab preferences
    // TODO: change to more related name
    setPref('.js-navigate-type', CARDS_PREFERRED_TAB, cardTabsPossibleValues);
    buildUrl('js-navigate-url', CARDS_PREFERRED_TAB, 'free', cardTabsPossibleValues);

    // Racecards list types preferences
    setPref('.js-rc-list-type', CARDS_LIST_VIEW_TYPE, cardListTypePossibleValues);
    buildUrl('js-rc-list-url', CARDS_LIST_VIEW_TYPE, 'byCourse', cardListTypePossibleValues);

    // Results list types preferences
    setPref('.js-rsp-list-type', RESULTS_LIST_VIEW_TYPE, resultsListTypePossibleValues);
    buildUrl('js-rsp-list-url', RESULTS_LIST_VIEW_TYPE, 'byCourse', resultsListTypePossibleValues);
}

exports.default = navigate;


//////////////////
// WEBPACK FOOTER
// ./~/rp-url-navigation-prefs/lib/navigate.js
// module id = 2619
// module chunks = 0